'ClueList'.list()
'Diagnosis Clues'.title()
'Back'.action({act: 'cancel'})
'Refresh'.action({act: "refresh"})
'Download to Excel'.action({act: 'excel'})
'Clue'.datatype()
'date'.field()
'time'.field()
'clientOrServer'.field()
'user'.field()
'point'.field()
'theDatatype'.field()
'castId'.field()
'product'.field({showAsLink: true})
'fieldName'.field()
'newValue'.field()
'oldValue'.field()
'reference'.field()
